import { render, staticRenderFns } from "./UserProfileForm.vue?vue&type=template&id=14a9ca56&"
import script from "./UserProfileForm.vue?vue&type=script&lang=ts&"
export * from "./UserProfileForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports